/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Requestdeclinename2Inputs */

const en_requestdeclinename2 = /** @type {(inputs: Requestdeclinename2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Decline ${i?.name}`)
};

const de_requestdeclinename2 = /** @type {(inputs: Requestdeclinename2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ablehnen`)
};

/**
* | output |
* | --- |
* | "Decline {name}" |
*
* @param {Requestdeclinename2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestdeclinename2 = /** @type {((inputs: Requestdeclinename2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestdeclinename2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestdeclinename2(inputs)
	return de_requestdeclinename2(inputs)
});
export { requestdeclinename2 as "requestDeclineName" }